import React, {useContext} from 'react';
import {useQuery} from "@apollo/client";
import {getCategories} from "../components/provider/category/CategoryQueries";
import {getUnits} from "../components/provider/unit/UnitQueries";
import {getIngredients} from "../components/provider/ingredients/IngredientQueries";
import {AuthContext} from "./authContext";
import {getCartItems} from "../components/client/shopping/CartQueries";
import {getPlan} from "../components/users/UserQueries";

export const UserContext = React.createContext();

export default function UserContextProvider({children}) {
  const {user} = useContext(AuthContext)

  const client_skip = !user || user.type === 'client'
  const provider_skip = !user || user.type === 'provider'

  // only for providers
  const {data: plan, refetch: planRefresh} = useQuery(getPlan, {skip: client_skip})
  const {data: categories} = useQuery(getCategories, {skip: client_skip})
  const {data: units} = useQuery(getUnits, {skip: client_skip})
  const {data: ingredients} = useQuery(getIngredients, {skip: client_skip})

  // only for clients
  const {data: carts} = useQuery(getCartItems, {skip: provider_skip})
  
  let res = {
    plan: plan ? plan.plan : [],
    units: units ? units.units : [],
    categories: categories ? categories.categories : [],
    ingredients: ingredients ? ingredients.ingredients : [],
    carts: carts ? carts.carts : [],
    planRefresh: planRefresh
  }

  return (
    <UserContext.Provider value={res}>
      {children}
    </UserContext.Provider>
  )
}
